import { Client } from "./Client";
import { UserEndpoint } from "@api/endpoints";
import { CognitoSessionHeader } from '@shared/utilities';

// Asks for a Cognito session; the API falls back to its own when Cognito didn't sign the user in.
const sessionHeaders = { [CognitoSessionHeader.name]: CognitoSessionHeader.value };

export class AuthApi {
  static login (request: UserEndpoint.Login.Request): Promise<UserEndpoint.Login.Response> {
    return Client(`login`, { body: request, headers: sessionHeaders });
  }

  static async logout (request: UserEndpoint.Logout.Request = {}) {
    await Client(`logout`, { body: request });
  }

  static async changePassword (request: UserEndpoint.ChangePassword.Request) {
    await Client('change-password', { body: request });
  }

  static async requestPasswordReset (request: UserEndpoint.RequestPasswordReset.Request) {
    await Client(`request-password-reset`, { body: request });
  }

  static async resetPassword (request: UserEndpoint.PasswordReset.Request) {
    await Client('password-reset', { body: request });
  }

  static async sendOtpCode (
    request: UserEndpoint.SendOtpCode.Request,
  ): Promise<UserEndpoint.SendOtpCode.Response> {
    return Client('send-otp-code', { body: request });
  }

  static async validateOtp (
    data: UserEndpoint.ValidateOtp.Request,
  ): Promise<UserEndpoint.ValidateOtp.Response> {
    return Client(`validate-otp`, {
      body: data,
      headers: sessionHeaders,
    });
  }
}
